import Axios from '../../../utils/tms-axios/tms-axios';

export const NakshatramCalendarService = {
  getAll: async (
    fromDate,
    toDate,
    nakshatramId = undefined,
    page = 1,
    limit = 10
  ) => {
    const resp = await Axios.get(`/v1/nakshatram-calendar/all`, {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        nakshatramId: nakshatramId,
        page: page,
        limit: limit,
      },
    });

    return resp.data;
  },

  createCalendarEntry: async (date, nakshatramIds) => {
    const resp = await Axios.post(`/v1/nakshatram-calendar/create`, {
      date: date,
      nakshatramIds: nakshatramIds,
    });

    return resp.data;
  },

  deleteNakshatram: async (nakshatramCalendarId) => {
    const resp = await Axios.delete(
      `/v1/nakshatram-calendar/delete/${nakshatramCalendarId}`,
      {}
    );

    return resp.data;
  },
};
